import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { NgIf } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { FloatLabelModule } from 'primeng/floatlabel';
import { FormsModule } from '@angular/forms';
import { ILocation } from '../../../models/location';

@Component({
  selector: 'lib-address-editor',
  standalone: true,
  imports: [DialogModule, ButtonModule, InputTextModule, FloatLabelModule, NgIf, FormsModule],
  templateUrl: './address-editor.component.html',
})
export class AddressEditorComponent implements OnChanges
{
  @Input() visible = false;
  @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Input() address?: ILocation;
  @Output() save: EventEmitter<ILocation> = new EventEmitter<ILocation>();
  @Output() cancel: EventEmitter<void> = new EventEmitter<void>();

  workingAddress: ILocation = { id: 0, street1: '', street2: '', city: '', state: '', zipCode: '', latitude: 0, longitude: 0 };

  ngOnChanges(changes: SimpleChanges)
  {
    if (changes['address'] || (changes['visible'] && this.visible))
    {
      if (this.address)
      {
        this.workingAddress = { ...this.address };
      }
      else
      {
        this.workingAddress = { id: 0, street1: '', street2: '', city: '', state: '', zipCode: '', latitude: 0, longitude: 0 };
      }
    }
  }

  close()
  {
    this.visible = false;
    this.visibleChange.emit(this.visible);
  }

  onSave()
  {
    this.save.emit({ ...this.workingAddress });
    this.close();
  }

  onCancel()
  {
    this.cancel.emit();
    this.close();
  }
}
